import React, { Component } from 'react';
import { Title, Error } from '../../library';
import JobTypeButton from './JobTypeButton/JobTypeButton';
import styles from './styles';
import { css } from 'aphrodite';

class JobType extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedType: null,
            isError: props.isError,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.isError !== this.props.isError) {
            this.setState({isError: this.props.isError},()=>{
                if(this.state.jointWidth === "") this.setState({widthError: true});
                if(this.state.jointDepth === "") this.setState({depthError: true});
            });
        }
    }

    selectType(type) {
        this.setState({jobType: type, backerRodPackage: null});
        this.props.onJointTypeSelected(type);
    }

    render() {
        const { title, squareJointLabel, triangleJointLabel, errorLabel } = this.props;

        return (
            <div className={css(styles.jobType)}>
                <div className={css(styles.wrapper)}>
                    <Title style={styles.h3}>{title}</Title>

                    <div className={css(styles.jobTypeContent, this.state.isError && styles.containerError)}>
                        <div className={css(styles.jobTypeButtonWrapper)}>
                            <JobTypeButton
                                type={'triangle'}
                                title={triangleJointLabel}
                                isSelected={this.state.jobType && this.state.jobType === "triangle"}
                                onSelectType={() => this.selectType("triangle")}
                            />
                        </div>
                        <div className={css(styles.jobTypeButtonWrapper)}>
                            <JobTypeButton
                                type={'square'}
                                title={squareJointLabel}
                                isSelected={this.state.jobType && this.state.jobType === "square"}
                                onSelectType={() => this.selectType("square")}
                            />
                        </div>
                    </div>

                </div>
                {this.state.isError &&
                <div className={css(styles.error)}>
                    <Error label={errorLabel}/>
                </div>
                }
            </div>
        );
    }
}

export default JobType;
